export const clearData = ({
                              setLoginInfo,
                              setPersonalData,
                              setFinancialInfo,
                              setAffiliationField,
                              setExpInfoData,
                              setConditionInfo,
                              setCustodialData,
                              setOwnerData,
                              setAuthInfo,
                              setVerifyInfo,
                              setAppData
                          }) => {
    setAppData({
        account_type: 'individual',
        sub_account_type: '',
        email: '',
        password: '',
        confirm_password: '',
        hear_about_us: '',
        citizenship_status: '',
        app_id: '',
        specialtyAccountType: 'C',
        country_of_birth: '',
        country_of_residence: '',
        country_of_citizenship: '',
        clientIP: ''
    })
    setPersonalData({
        title: '',
        firstName: '',
        lastName: '',
        middleName: '',
        birth: '',
        ssn: '',
        confirmSsn: '',
        phone: '',
        maritalStatus: '',
        idenType: '',
        idenNumber: '',
        issueDate: '',
        expDate: '',
        permAddress: '',
        address2: '',
        city: '',
        country: '',
        zipCode: '',
        state: '',
        mailingCountry: '',
        mailingAddress: '',
        mailingAddress2: '',
        mailingCity: '',
        mailingZipCode: '',
        mailingState: '',
        trustName: '',
        trustCountry: '',
        mailingDiff: ''
    });
    setFinancialInfo({
        emplStatus: '',
        sourceOfIncome: '',
        sourceOfWealth: '',
        annualIncome: '',
        assets: '',
        netWorth: '',
        schoolName: '',
        occupation: '',
        companyName: '',
        businessState: '',
        businessAddress: '',
        city: '',
        zipCode: '',
        countryName: '',
        businessPhone: '',
        soldBusinessName: '',
        soldAmount: '',
        soldBusinessDate: ''
    })
    setAffiliationField({
        questions: [
            {
                id: 1,
                name: 'AffiliationMember',
                text: 'affiliation.are_member',
                selected: false
            },
            {
                id: 2,
                name: 'AffiliationBroker',
                text: 'affiliation.NFA_or_CFTC',
                selected: false
            },
            {
                id: 3,
                name: 'AffiliationForShellBank',
                text: 'affiliation.foreign_shell',
                selected: false
            },
            {
                id: 4,
                name: 'AffiliationShellBank',
                text: 'affiliation.owner_affiliated',
                selected: false
            },
            {
                id: 5,
                name: 'AffiliationShellBankService',
                text: 'affiliation.owner_offer',
                selected: false
            },
            {
                id: 6,
                name: 'AffiliationBankrupt',
                text: 'affiliation.bankruptcy_proceeding',
                selected: false
            },
            {
                id: 7,
                name: 'AffiliationLegal',
                text: 'affiliation.commodity_account',
                selected: false
            },
            {
                id: 8,
                name: 'AffiliationUnpaid',
                text: 'affiliation.commodity_firm',
                selected: false
            },
            {
                id: 9,
                name: 'AffiliationOtherFunds',
                text: 'affiliation.business_with_you',
                selected: false
            },
            {
                id: 10,
                name: 'AffiliationFFI',
                text: 'affiliation.financial_institution',
                selected: false
            },
            {
                id: 11,
                name: 'AffiliationPoliOfficial',
                text: 'affiliation.close_associate',
                selected: false
            }
        ],
        name: '',
        process: '',
        position: '',
        affPerson: '',
        companyName: '',
        organizations: '',
        memberPosition: '',
        memberAffPerson: '',
        memberCompanyName: ''
    })
    setExpInfoData({
        stockYear: '',
        stockAverageSize: '',
        stockAverageNumber: '',
        optionYear: '',
        optionAverageSize: '',
        optionAverageNumber: '',
        invest_obj: ''
    })
    setConditionInfo({
        customer: '',
        margin: '',
        option: '',
        taxPlayer: '',
        clear: '',
        agreew8: '',
        disclosure: '',
        privacy: '',
        agreeConfirm: '',
        agreeEstatement: '',
        agreeProxy: '',
        agreePros: '',
        agreeEtax: '',
        finder: ''
    })
    setLoginInfo({
        email: '',
        password: ''
    })
    setCustodialData({
        custodial_first_name: '',
        custodial_last_name: '',
        custodial_middle_name: '',
        custodial_ssn: '',
        custodial_birth: '',
        custodial_type: 'UTMA'
    })
    setOwnerData({
        joint_title: '',
        joint_first_name: '',
        joint_last_name: '',
        joint_middle_name: '',
        joint_birth: '',
        joint_citizenship_status: '',
        joint_ssn: '',
        joint_confirm_ssn: '',
        joint_iden_type: '',
        joint_iden_number: '',
        joint_issue_date: '',
        joint_exp_date: '',
        joint_spouse: 'N',
        joint_same_add: 'Y',
        joint_mobile_phone: '',
        joint_home_phone: '',
        joint_emp_status: '',
        joint_member: 'N',
        joint_indicate1: '',
        joint_indicate2: '',
        joint_occupation: '',
        joint_company_name: '',
        joint_address: '',
        joint_city: '',
        joint_business_country: '',
        joint_business_state: '',
        joint_zip_code: '',
        joint_school_name: '',
        joint_no_address: '',
        joint_no_address2: '',
        joint_no_city: '',
        joint_no_country: '',
        joint_no_zip_code: '',
        country_of_birth: '',
        country_of_residence: '',
        country_of_citizenship: '',
        joint_no_state: ''
    })
    setAuthInfo([{
        checked: false,
        auth_title: '',
        auth_first_name: '',
        auth_middle_name: '',
        auth_last_name: '',
        auth_entity_role: ''
    }])
    setVerifyInfo({
        email: "",
        new_password: "",
        confirm_new_password: "",
    })
}